const PublicPageReviewCardSkeleton = () => {
  return (
    <div
      className="rounded-2xl border bg-white p-4"
      style={{ boxShadow: '0px 3px 10px 1px rgba(220, 219, 218, 0.25)' }}
    >
      <div className="flex items-center gap-3">
        <div className="size-[50px] animate-pulse rounded-full bg-gray-200 object-cover" />
        <div>
          <div className="mb-1 h-5 w-32 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
      <div className="mt-3 h-4 w-full animate-pulse rounded bg-gray-200" />
      <div className="mt-2 h-4 w-3/4 animate-pulse rounded bg-gray-200" />
      <div className="mt-3 flex flex-row items-center gap-2 text-sm text-muted">
        <div className="size-4 animate-pulse rounded bg-gray-200" />
        <span className="flex flex-row gap-0.5">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="size-4 animate-pulse rounded bg-gray-200" />
          ))}
        </span>
        <span className="size-4 animate-pulse rounded bg-gray-200" />
        <span className="h-4 w-16 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
  )
}

export default PublicPageReviewCardSkeleton
